module.exports = __webpack_public_path__ + "static/media/Komal Kadambi Seshachari.277f89fa.png";